module.exports = __webpack_public_path__ + "img/Obstfelder_Aften_på_Karl_Johan.f48b215a.jpg";